import React from 'react';
import { MAPLE_DECOS, SHARED_HERO_DECORATIONS } from '../../../shared/config/decorations';
import { AnimatedMaple } from './AnimatedMaple';
import { MapleFrontLayer } from './MapleFrontLayer.styles';

/** 투표 hero 카피 위에 올리는 작은 단풍 */
export function VoteMapleOverText() {
  return (
    <MapleFrontLayer aria-hidden="true">
      <AnimatedMaple src={SHARED_HERO_DECORATIONS.decorationMaple} config={MAPLE_DECOS.vote} />
    </MapleFrontLayer>
  );
}
